import { IconKey,IconDeviceWatch } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconDeviceWatch
};
//

const Operations = {

    id: 'operations',
    title: 'Operations',
    type: 'group',
    display_id:'P',
    icon: icons.IconDeviceWatch,
    children: [
        {
            id: 'operations_dashboard_transaction',
            title: 'Transaction',
            type: 'item',
            display_id:50,
            url: '/Department/Operation/transactions',
            breadcrumbs: false
        },
        {
            id: 'operations_dashboard_code_activation',
            title: 'Code Activation',
            type: 'item',
            display_id:63,
            url: '/Department/Operation/code_activation',
            breadcrumbs: false
        },
        {
            id: 'operations_dashboard_mandate',
            title: 'Mandate',
            type: 'item',
            display_id:64,
            url: '/Department/Operation/mandate',
            breadcrumbs: false
        },
    ]
}

export default Operations;